import { render, staticRenderFns } from "./ObjectPopup.vue?vue&type=template&id=bba2e45a"
import script from "./ObjectPopup.vue?vue&type=script&lang=ts"
export * from "./ObjectPopup.vue?vue&type=script&lang=ts"
import style0 from "./ObjectPopup.vue?vue&type=style&index=0&id=bba2e45a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports